import { CheckIcon, DashIcon, SyncIcon } from "@codat/orchard-ui";
import { SourceTypeResponse } from "api/company";
import classNames from "classnames";
import { SourceType } from "model";
import { sourceTypeHasData } from "utils";

import styles from "./LinkedAccountIcon.module.css";

interface LinkedAccountIconProps {
  sourceType: SourceTypeResponse;
  currentSourceType?: SourceType;
  className?: string;
}

export const LinkedAccountIcon: React.FC<LinkedAccountIconProps> = ({
  sourceType,
  currentSourceType,
  className,
}) => {
  const icon = (() => {
    if (sourceType.sourceType === currentSourceType) {
      return (
        <SyncIcon
          data-testid={`sync-icon-${sourceType.sourceType.toLowerCase()}`}
        />
      );
    } else if (sourceTypeHasData(sourceType)) {
      return (
        <CheckIcon
          data-testid={`check-icon-${sourceType.sourceType.toLowerCase()}`}
        />
      );
    } else {
      return (
        <DashIcon
          data-testid={`dash-icon-${sourceType.sourceType.toLowerCase()}`}
        />
      );
    }
  })();

  return (
    <span
      data-testid="linked-account-icon"
      className={classNames(styles.icon, className)}
    >
      {icon}
    </span>
  );
};
